import FormInviteWrapper from './FormInviteWrapper.vue';

export default FormInviteWrapper;



// WEBPACK FOOTER //
// ./src/components/page/invite/wrapper/index.ts